import * as React from "react"
import { type VariantProps } from "class-variance-authority"
import buttonVariants from "./buttonVariants"
import { Slot, Slottable } from "@radix-ui/react-slot"
import LoadingIndicator from "../../../assets/icons/LoadingIndicator"
import { cn } from "../../../utils"

export interface ButtonProps
  extends
    React.ComponentPropsWithoutRef<"button">,
    VariantProps<typeof buttonVariants> {
  isLoading?: boolean
  icon?: React.ReactNode
  asChild?: boolean
}

function Button({
  className,
  variant,
  isLoading,
  icon,
  children,
  disabled,
  asChild = false,
  ...props
}: ButtonProps) {
  const Comp = asChild ? Slot : "button"

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, className }), {
        "bg-primary-dark-green pointer-events-none text-white": isLoading,
      })}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && <LoadingIndicator />}
      {icon && icon}
      <Slottable>{children}</Slottable>
    </Comp>
  )
}

export default Button
